import adapter from './adapter'

export default {
  events: adapter('api/events'),
  reservations: adapter('api/reservations'),
  ridingschool: adapter('api/ridingschool'),
  templates: adapter('api/templates')
}
